import React, { Component } from 'react';
import RightSearchBar from '../components/RightSearchBar';
import MapCard from '../components/MapCard';
import Card from '../components/Card';
import SemanticTableHousing from '../components/SemanticTableHousing';
import Base from './Base';
require('dotenv').config()


class OpenResidentialRegistry extends Component {

  constructor() {
  super();
  this.state = {
       residences: [],
       dataColumns:[
       {name:'id', prettyName: 'Valueguard ID', priority: 'High'},
       {name:'address', prettyName: 'Adress', priority:'high'},
       {name:'construction_year', prettyName: 'Byggår', priority:'normal'},
       {name:'home_type', prettyName: 'Home type', priority:'normal'},
       {name:'apartment_category', prettyName: 'Apartment category', priority:'low'},
       {name:'apartment_nr', prettyName: 'Lägenhetsnummer', priority:'low'},
       {name:'rooms', prettyName: 'Rum', priority:'low'},
       {name:'apartment_area', prettyName: 'Boyta', priority:'low'},
       {name:'floor', prettyName: 'Våning', priority:'low'},
       {name:'area_name', prettyName: 'Area name', priority:'low'},
       {name:'building_purpose', prettyName: 'Building purpose', priority:'low'},
       {name:'building_type', prettyName: 'Building type', priority:'low'},
       {name:'county_code', prettyName: 'County code', priority:'low'},
       {name:'floors', prettyName: 'Våningar', priority:'low'},
       {name:'house_nr', prettyName: 'House nr', priority:'low'},
       {name:'kitchen_type', prettyName: 'Kitchen type', priority:'low'},
       {name:'municipality_code', prettyName: 'Municipality code', priority:'low'},
       {name:'owner_id', prettyName: 'Owner id', priority:'low'},
       {name:'ownership_type', prettyName: 'Ägandetyp', priority:'low'},
       {name:'postal_area', prettyName: 'Postort', priority:'high'},
       {name:'property_key', prettyName: 'Fastighetsnyckel', priority:'low'},
       {name:'type_code', prettyName: 'Type code', priority:'low'}],
       markerTopic: "adress",
       searchCriteria: [{name:'Adress', id:0, pageClass: 'card', fields:{
         'street':{'value':'', 'title':'Gata', 'type':'text', 'placeholder':'Gata'},
         'number':{'value':'', 'title':'Gatunummer', 'type':'text', 'placeholder':'Gatunummer'},
         'letter':{'value':'', 'title':'Gatunummer bokstav', 'type':'text', 'placeholder':'Gatunummer bokstav'},
         'apartment_nr':{'value':'', 'title':'Lägenhetsnummer', 'type':'text', 'placeholder':'Lägenhetsnummer'},
         'postal_area':{'value':'', 'title':'Postort', 'type':'text', 'placeholder':'Postort'}
       }}],
       mapPositionLat: 59.862215,
       mapPositionLng: 17.641340,
       mapZoomLevel: 13,
       token: ""
     }
   this.makeResidentialRegistrySearch = this.makeResidentialRegistrySearch.bind(this);
   this.updateSearchCriteria = this.updateSearchCriteria.bind(this);
  }

 updateSearchCriteria(event){
   let tmp_searchCriteria = this.state.searchCriteria;
   let sectionid =event.target.attributes.getNamedItem('sectionid').value;
   tmp_searchCriteria[sectionid]['fields'][event.target.name]['value'] = event.target.value
   this.setState({searchCriteria: tmp_searchCriteria});
 }



  makeResidentialRegistrySearch = () =>{
    let urlSearchCriteria=""
    this.state.searchCriteria.map(function(section, i){
      Object.keys(section['fields']).forEach(function(key) {
         if (section['fields'][key]['value']){
           urlSearchCriteria += '&' + key + "=" + section['fields'][key]['value']
         }
    }, this)});


    fetch(global.apiUrl + '/v1/residential/registry?access_token=' + this.state.token + '&limit=1' + urlSearchCriteria)
    .then(res => res.json())
    .then((data) => {
      this.setState({ residences: data['residences'] });
      if (data['residences'][0]){
        this.setState({ mapPositionLat: data['residences'][0]['wgs84lat'] });
        this.setState({ mapPositionLng: data['residences'][0]['wgs84lon'] });
        this.setState({ mapZoomLevel: 14 });
      }
      //console.log(this.state.residences)
    })
    .catch(console.log);
  }

  componentDidMount() {
    let username="residential_registry_public"
    let password="6nuBPdh0r6fwwoAQLpx"
    let token=""
    const requestOptions = {
	crossDomain:true,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
    };
    fetch(global.apiUrl + '/oauth/token?client_id=api&grant_type=password&username=' + username + '&password=' + password, requestOptions)
    .then(res => res.json())
    .then((data) => {
        this.setState({ token: data['access_token']});
      })
    .catch(console.log);
  }

  render() {


      return (
        <Base pageTopic={"Bostadsregistret"} mainContent={ <>
        <Card title="Välkommen till Valueguards informationstjänst för Bostadsregistret" body={
            <p> Här kan du till exempel se om din bostad finns i registret och vilken information som finns registrerad om den.
            Skriv in adressen till höger så visas informationen under kartan.</p>
          }></Card>
        <MapCard polylines={[[  [51.505, -0.09], [51.51, -0.1],  [51.51, -0.12],]]} polygons={[[ [51.515, -0.09], [51.52, -0.1], [51.52, -0.12],]]} markers={this.state.residences} lonName={"wgs84lon"} latName={"wgs84lat"} markerTitle={this.state.markerTopic} markerPopupColumns={this.state.dataColumns}  mapPositionLat={this.state.mapPositionLat}   mapPositionLng={this.state.mapPositionLng}  mapZoomLevel={this.state.mapZoomLevel}></MapCard>
          <SemanticTableHousing title="Bostäder" tableData={this.state.residences} dataColumns={this.state.dataColumns} getValuationFunction={this.getValuation}></SemanticTableHousing>
          </>}
          searchBar={ <RightSearchBar searchCriteria={this.state.searchCriteria} updateSearchCriteria={this.updateSearchCriteria} searchFunction={this.makeResidentialRegistrySearch} ></RightSearchBar>
        }></Base>
	     )
  }
}

export default OpenResidentialRegistry;
